import { fontHeadings } from "../../../../enums/font";
import { loadFonts } from "../../../../utils/LoadSiteFonts";
import { IColorOverride } from "../../interfaces/IColorOverride";
import { overrideColorsToCssVars } from "../../utils/overrideColorsToCssVars";
import styles from "./ModernMonogramStrikethrough.module.scss";

export interface IProps {
    eventLogo: IEventLogoModernMonogramStrikethrough;
    type: "SITE" | "PRINT";
    cssVarsOnly: string;
}

export interface IPropsDemo {
    type: "DEMO";
    cssVarsOnly: string;
}

export interface IEventLogoModernMonogramStrikethrough {
    name: "ModernMonogramStrikethrough";
    name1: string;
    name2: string;
    colorText: IColorOverride;
}

export const ModernMonogramStrikethrough = (props: IProps | IPropsDemo) => {
    const eventLogo: Omit<IEventLogoModernMonogramStrikethrough, "name"> =
        props.type !== "DEMO"
            ? props.eventLogo
            : {
                  name1: "Alice",
                  name2: "Theo",
                  colorText: { override: false, color: null },
              };
              
    const fontFamilyInitials = fontHeadings[1];
    const fontFamilyNames = fontHeadings[16];

    loadFonts([
        { font: fontFamilyInitials, type: "ONLY_400" },
        { font: fontFamilyNames, type: "ONLY_400" },
    ]);

    const names = eventLogo.name1.toLocaleUpperCase() + " & " + eventLogo.name2.toLocaleUpperCase();
    return (
        <div
            className={`${styles.wrapper} ${styles[props.type]} ${props.cssVarsOnly}`}
            style={overrideColorsToCssVars([{ name: "text", colorOverride: eventLogo.colorText }])}
        >
            <div className={styles.namesAndInitials}>
                <div className={styles.initials} style={{ fontFamily: fontFamilyInitials }}>
                    <div className={styles.inner}>
                        {eventLogo.name1.slice(0, 1).toLocaleUpperCase()}{" "}
                        {eventLogo.name2.slice(0, 1).toLocaleUpperCase()}
                    </div>
                </div>
                <div className={styles.names} style={{ fontFamily: fontFamilyNames }}>
                    {names.split("").map((letter, index) => (
                        <span key={index}>{letter}</span>
                    ))}
                </div>
            </div>
        </div>
    );
};
